import styled from '@emotion/styled';
import { layout, palette, radius, spacing, typography } from '../../../../style-utils/theme';

/**
 * THE STAY GUEST'S FULL CHECK-IN — the few arrangements plan S6 adds on top of
 * S3's guest kit (components/onboarding/stay/public-stay-page.styled.tsx,
 * re-used for buttons, facts, party rows). Tokens only; phone first (WebKit,
 * 320 px); every control 44 px; the last action sits above var(--safe-bottom)
 * through S3's Actions.
 */

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin: 0 0 ${spacing.sm};
  min-width: 0;
`;

export const Line = styled.p`
  margin: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  line-height: ${typography.leading.normal};
  color: ${palette.slate};
  overflow-wrap: anywhere;
`;

export const StrongLine = styled(Line)`
  font-size: ${typography.size.base}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
`;

export const StepHeading = styled.h2`
  margin: ${spacing.sm} 0 ${spacing.xs};
  font-family: ${typography.ui};
  font-size: ${typography.size.lg}px;
  font-weight: ${typography.weight.bold};
  line-height: ${typography.leading.snug};
  color: ${palette.ink};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  margin: 0 0 ${spacing.sm};
  min-width: 0;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surfaceMuted};
`;

export const RulesText = styled.div`
  max-height: 50vh;
  max-height: 50dvh;
  overflow-y: auto;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surface};
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  line-height: ${typography.leading.relaxed};
  color: ${palette.ink};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const PersonGrid = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  margin: 0 0 ${spacing.sm};
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surface};
`;

export const Legend = styled.legend`
  padding: 0 ${spacing.half};
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.inkSoft};
`;

export const Note = styled.p`
  margin: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  line-height: ${typography.leading.normal};
  color: ${palette.slate};
  overflow-wrap: anywhere;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
`;

export const Reason = styled.span`
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.slate};
`;

export const SelectWrap = styled.div`
  min-height: ${layout.touchTarget};
`;
